import styles from './dashboard-visit-card.module.css';
import { formatDate } from '@/util/formats';
import { EncounterSummaryItem } from '@/api/api.schemas';
import { Button } from '../button';
import clsx from 'clsx';
import { Section } from '../containers/section';
import { Separator } from '../separator';
import { useTranslation } from '@/contexts/i18n-context';

interface DashboardVisitCardProps {
  encounter: EncounterSummaryItem;
}

const translationBase = 'dashboard.visitCard';

export function DashboardVisitCard({ encounter }: DashboardVisitCardProps) {
  const { t } = useTranslation();

  return (
    <Section className={styles.visitCard}>
      <div className={styles.visitCardTitle}>
        <div className={styles.visitDate}>
          <p className="overline">{t(`${translationBase}.header`, { number: encounter.id })}</p>
          <p className={clsx(styles.date, 'body-3')}>
            {formatDate(encounter.lastStatusDate, { format: 'user' })}
          </p>
        </div>
        <Button
          size="S"
          variant="link"
          as="a"
          to={`/visit/${encounter.id}/tx-plan/treatment`}
          rightIcon="arrow_forward"
        >
          {t(`${translationBase}.viewVisit`)}
        </Button>
      </div>

      <Separator />

      <div className={styles.visitDetails}>
        {encounter.assignedProvider ? (
          <div className={styles.assignedProviderContainer}>
            <p className={clsx(styles.assignedProviderName, 'semibold')}>
              {encounter.assignedProvider}
              {encounter.unreadMessages > 0 && (
                <span className={clsx(styles.badge, 'bold')}>{encounter.unreadMessages}</span>
              )}
            </p>
            {encounter.canMessage && (
              <Button
                size="S"
                variant="link"
                as="a"
                to={`/visit/${encounter.id}/tx-plan/messages`}
                leftIcon="mail"
              >
                {t(`${translationBase}.messageProvider`)}
              </Button>
            )}
          </div>
        ) : (
          <p className="semibold">{t(`${translationBase}.noAssignedProvider`)}</p>
        )}
        <p className={clsx('body-1', 'bold')}>{encounter.diagnosis}</p>
      </div>
    </Section>
  );
}
